<template>
    <main id="mainCtrl">
        <div class="nav-tabs-custom">
            <ul class="nav nav-tabs" v-cloak>
                <li class="active" id="tabSettings">
                    <a href="#">Основные</a>
                </li>
                <li id="tabAppearance">
                    <a href="/clinics/feedback/settings/appearance">Внешний вид</a>
                </li>
            </ul>
        </div>

        <ValidationObserver ref="validator">
            <form class="feedbackSettingsForm" v-cloak>
                <Alert>Для изменения ссылок обратитесь, пожалуйста, к персональному менеджеру.</Alert>
                <fieldset>
                    <legend>Площадки</legend>

                    <div>
                        <label>
                            <input type="checkbox"
                                   id="doctu-platform"
                                   v-model="isDoctuOn"
                                   @change="revertChange"
                                   :class="{hasError: platformsError}"
                                   v-tooltip="{
                                      content: platformsError,
                                      template: $errTemplate,
                                   }">
                            <span>
                                <svg viewBox="0 0 17 16" height="21" width="21">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.91671 12.4236C11.4606 12.4236 14.3334 9.64247 14.3334 6.21179C14.3334 2.78111 11.4606 0 7.91671 0C4.37286 0 1.5 2.78111 1.5 6.21179C1.5 9.64247 4.37286 12.4236 7.91671 12.4236ZM7.91676 9.58909C9.84352 9.58909 11.4055 8.07702 11.4055 6.21179C11.4055 4.34655 9.84352 2.83448 7.91676 2.83448C5.98999 2.83448 4.42804 4.34655 4.42804 6.21179C4.42804 8.07702 5.98999 9.58909 7.91676 9.58909Z" fill="#13A546"/>
                                    <path d="M11.0158 12.2491L13.9048 15.5026C14.4362 16.101 15.368 16.1691 15.9862 15.6547C16.6043 15.1403 16.6746 14.2381 16.1433 13.6397L13.3211 10.4616C12.6962 11.2055 11.9107 11.8178 11.0158 12.2491Z" fill="#13A546"/>
                                </svg>
                                <input type="text" v-model="linkToDoctuOn" @click.prevent="openLink" @input="linkToDoctuOn = originalData.linkToDoctuOn">
                            </span>
                        </label>

                        <label>
                            <input type="checkbox"
                                   id="yamaps-platform"
                                   v-model="isYandexMapsOn"
                                   @change="revertChange"
                                   :class="{hasError: platformsError}"
                                   v-tooltip="{
                                      content: platformsError,
                                      template: $errTemplate,
                                   }">
                            <span>
                                <svg viewBox="0 0 13 15" height="21" width="21">
                                    <path d="M6.5 0C3.19 0 0.5 2.69 0.5 6C0.5 7.66 1.17 9.16 2.26 10.24C3.35 11.33 5.9 12.9 6.05 14.55C6.07 14.8 6.25 15 6.5 15C6.75 15 6.93 14.8 6.95 14.55C7.1 12.9 9.66 11.33 10.74 10.24C11.83 9.15 12.5 7.65 12.5 6C12.5 2.69 9.81 0 6.5 0Z" fill="#FF4433"/>
                                    <path d="M6.49999 8.10039C7.65999 8.10039 8.59999 7.16039 8.59999 6.00039C8.59999 4.84039 7.65999 3.90039 6.49999 3.90039C5.33999 3.90039 4.39999 4.84039 4.39999 6.00039C4.39999 7.16039 5.33999 8.10039 6.49999 8.10039Z" fill="white"/>
                                </svg>
                                <input type="text" v-model="linkToYaMaps" @click="openLink" @input="linkToYaMaps = originalData.linkToYaMaps">
                            </span>
                        </label>

                        <label>
                            <input type="checkbox"
                                   id="twogis-platform"
                                   v-model="is2GisOn"
                                   @change="revertChange"
                                   :class="{hasError: platformsError}"
                                   v-tooltip="{
                                      content: platformsError,
                                      template: $errTemplate,
                                   }">
                            <span>
                                <svg viewBox="0 0 16 15" height="21" width="21">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 15C12.125 15 15.5 11.64 15.5 7.5C15.5 3.36 12.125 0 8 0C3.875 0 0.5 3.36 0.5 7.5C0.5 11.64 3.86 15 8 15Z" fill="#19AA1E"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.5498C10.475 2.5498 12.155 4.4548 12.155 6.5098C12.155 7.3348 11.975 8.0548 11.555 8.9548C9.095 8.9548 8.645 10.5898 8.54 11.6848L8.465 12.4498H7.535L7.46 11.6848C7.355 10.5898 6.905 8.9548 4.445 8.9548C4.025 8.0548 3.845 7.3348 3.845 6.5098C3.845 4.4548 5.525 2.5498 8 2.5498Z" fill="white"/>
                                </svg>
                                <input type="text" v-model="linkTo2Gis" @click="openLink" @input="linkTo2Gis = originalData.linkTo2Gis">
                            </span>
                        </label>

                        <label>
                            <input type="checkbox"
                                   id="google-platform"
                                   v-model="isGoogleOn"
                                   @change="revertChange"
                                   :class="{hasError: platformsError}"
                                   v-tooltip="{
                                      content: platformsError,
                                      template: $errTemplate,
                                   }">
                            <span>
                                <svg viewBox="0 0 12 16" height="21" width="21">
                                    <path d="M3.30428 11.8531C3.8356 12.4705 4.37673 13.2468 4.65991 13.7157C5.00478 14.3253 5.14777 14.7369 5.40432 15.4741C5.55432 15.8779 5.69732 16.0004 5.99732 16.0004C6.32537 16.0004 6.47537 15.7946 6.59032 15.4741C6.83005 14.7825 7.0151 14.2563 7.30809 13.7548C8.43802 11.7749 10.2801 10.3682 11.3175 8.4404C11.3175 8.4404 12.0002 7.2629 12.0002 5.61388C12.0002 4.07688 11.3273 3.00879 11.3273 3.00879L3.30848 11.8661L3.30428 11.8531Z" fill="#34A853"/>
                                    <path d="M0.584493 8.23157C1.23077 9.59924 2.46314 10.798 3.30428 11.8531L7.7622 6.94205C7.7622 6.94205 7.13275 7.70795 5.99581 7.70795C4.7285 7.70795 3.6967 6.77011 3.6967 5.5848C3.6967 4.76941 4.21961 4.2041 4.21961 4.2041C0.939173 4.65739 1.12142 5.39593 0.574679 8.22896L0.584493 8.23157Z" fill="#FBBC04"/>
                                    <path d="M7.81824 0.255859C9.30425 0.700027 10.566 1.63656 11.323 3.00423L7.76216 6.95094C7.76216 6.95094 8.28507 6.38303 8.28507 5.57024C8.28507 4.36018 7.18599 3.44709 5.99998 3.44709C4.81398 3.44709 4.23359 4.20387 4.23359 4.20387C4.50696 3.62554 7.33178 0.452544 7.82245 0.257162L7.81824 0.255859Z" fill="#4285F4"/>
                                    <path d="M1.39755 1.99289C2.28355 1.01338 3.83685 0 5.98175 0C7.01775 0 7.80422 0.255299 7.80422 0.255299L4.22938 4.20201C3.98826 4.08048 1.63587 2.37845 1.39755 1.98768V1.99289Z" fill="#1A73E8"/>
                                    <path d="M0.584493 8.23157C0.584493 8.23157 0 7.15352 0 5.60088C0 4.12901 0.619638 2.83949 1.4019 2.00586L4.23373 4.22019L0.588797 8.23202L0.584493 8.23157Z" fill="#EA4335"/>
                                </svg>
                                <input type="text" v-model="linkToGoogle" @click="openLink" @input="linkToGoogle = originalData.linkToGoogle">
                            </span>
                        </label>
                    </div>
                </fieldset>

                <fieldset>
                    <legend>Уведомления</legend>

                    <div>
                        <label>Перехваченные негативные отзывы</label>
                        <vee-input v-model="email" placeholder="Email" rules="required|email" name="Email"/>
                    </div>
                </fieldset>

                <footer style="margin-top: 5px">
                    <v-loading-component @click="save">
                        <template slot-scope="{ loadingClass }">
                            <button :disabled="noChanges" :class="[{green: !noChanges}, loadingClass]">
                                Сохранить
                            </button>
                        </template>
                    </v-loading-component>
                </footer>
            </form>
        </ValidationObserver>
    </main>
</template>

<script setup lang="ts">
// @ts-ignore
import Alert from "@common/Alert.vue";
import {computed, getCurrentInstance, nextTick, reactive, ref} from "vue";
import axios from "axios";

const $errTemplate = ref(getCurrentInstance().proxy.$errTemplate);
const props = defineProps({
    isYandexMapsSelected: {
        type: Boolean,
        required: true,
    },
    is2GisSelected: {
        type: Boolean,
        required: true,
    },
    isDoctuSelected: {
        type: Boolean,
        required: true,
    },
    isGoogleSelected: {
        type: Boolean,
        required: true,
    },
    selectedEmail: {
        type: String,
        required: true,
    },
    linkTwoGis: {
        type: String,
        required: false,
        default: () => null,
        nullable: true,
    },
    linkYaMaps: {
        type: String,
        required: false,
        default: () => null,
        nullable: true,
    },
    linkDoctuOn: {
        type: String,
        required: false,
        default: () => null,
        nullable: true,
    },
    linkGoogle: {
        type: String,
        required: false,
        default: () => null,
        nullable: true,
    },
    linkGoogle: {
        type: String,
        required: false,
        default: () => null,
        nullable: true,
    },
});
const isYandexMapsOn = ref(props.isYandexMapsSelected);
const is2GisOn = ref(props.is2GisSelected);
const isDoctuOn = ref(props.isDoctuSelected);
const isGoogleOn = ref(props.isGoogleSelected);
const email = ref(props.selectedEmail);
const linkToYaMaps = ref(props.linkYaMaps);
const linkTo2Gis = ref(props.linkTwoGis);
const linkToDoctuOn = ref(props.linkDoctuOn);
const linkToGoogle = ref(props.linkGoogle);

const originalData = reactive({
    isYandexMapsOn: props.isYandexMapsSelected,
    is2GisOn: props.is2GisSelected,
    isDoctuOn: props.isDoctuSelected,
    isGoogleOn: props.isGoogleSelected,
    email: props.selectedEmail,
    linkToYaMaps: props.linkYaMaps,
    linkTo2Gis: props.linkTwoGis,
    linkToDoctuOn: props.linkDoctuOn,
    linkToGoogle: props.linkGoogle,
});

// validator ref
const validator = ref(null);

const revertChange = (event) => {
    const el = event.target;
    const inputLink = el.parentElement.querySelector('span').querySelector('input');

    if (el.checked && !inputLink.value) {
        nextTick(() => {
            el.classList.add('hasError');
            el.checked = !el.checked;

            if (el.id === 'doctu-platform') {
                isDoctuOn.value = false;
            } else if (el.id === 'twogis-platform') {
                is2GisOn.value = false;
            } else if (el.id === 'yamaps-platform') {
                isYandexMapsOn.value = false;
            } else if (el.id === 'google-platform') {
                isGoogleOn.value = false;
            }
        });
    }
}

const openLink = (event) => {
    const el = event.target;
    const link = el.value;

    el.blur();

    if (link) {
        window.open(link, '_blank')
    }
}

const save = (btn) => {
    if (noChanges.value) {
        return;
    }

    btn.startLoadingAnimation();

    validator.value.validate().then(success => {
        if (platformsError.value || !success) {
            btn.stopLoadingAnimation();
            return;
        }

        const data = {
            isYandexMapsOn: isYandexMapsOn.value,
            is2GisOn: is2GisOn.value,
            isDoctuOn: isDoctuOn.value,
            isGoogleOn: isGoogleOn.value,
            email: email.value,
        };

        Object.assign(originalData, data);

        axios.post('settings/save', data)
            .then(() => btn.stopLoadingAnimation());
    });
}

const doctuError = computed(() => {
    const result = isDoctuOn.value && !linkToDoctuOn.value ? 'Отсутствует ссылка для платформы' : false;

    if (result) {
        isDoctuOn.value = false;
    }

    return result;
});

const twoGisError = computed(() => {
    const result = is2GisOn.value && !linkTo2Gis.value ? 'Отсутствует ссылка для платформы' : false;

    if (result) {
        is2GisOn.value = false;
    }

    return result;
});

const yaMapsError = computed(() => {
    const result = isYandexMapsOn.value && !linkToYaMaps.value ? 'Отсутствует ссылка для платформы' : false;

    if (result) {
        isYandexMapsOn.value = false;
    }

    return result;
});

const googleError = computed(() => {
    const result = isGoogleOn.value && !linkToGoogle.value ? 'Отсутствует ссылка для платформы' : false;

    if (result) {
        isGoogleOn.value = false;
    }

    return result;
});

const platformsError = computed(() => {
    return (+isYandexMapsOn.value + +is2GisOn.value + +isDoctuOn.value + +isGoogleOn.value) === 0 ?
        'Должна быть выбрана хотя бы одна площадка' :
        '';
});

const noChanges = computed(() => {
    return JSON.stringify(originalData) === JSON.stringify({
        isYandexMapsOn: isYandexMapsOn.value,
        is2GisOn: is2GisOn.value,
        isDoctuOn: isDoctuOn.value,
        isGoogleOn: isGoogleOn.value,
        email: email.value,
        linkToYaMaps: linkToYaMaps.value,
        linkTo2Gis: linkTo2Gis.value,
        linkToDoctuOn: linkToDoctuOn.value,
        linkToGoogle: linkToGoogle.value,
    });
});
</script>

<style lang="scss">
.feedbackSettingsForm{
    fieldset {
        width: 552px;

        input[type=checkbox].hasError:focus:not([readonly]):not(.switch):not([disabled]):not(.attentionValidationOnSubmitError) {
            border-color: #d04444 !important;
            background-color: rgba(253, 125, 125, 0.0784313725) !important;
        }

        input[type=text]:not([placeholder=Email]) {
            background-color: white;
            color: #0d6aad;
            cursor: pointer;
            width: 489px;
        }

        label {
            span {
                display: inline-flex;
                gap: 5px;
            }
        }
    }

    .component-alert {
        width: 552px;
    }
}
</style>
